const PRODUCTS_STOCKS_TABLE_READY = "products-stocks-table-ready"
const SEARCH_TEXT_STATE = "products-stocks-table-search-text-state"
const ROWS_PER_PAGE_STATE = "products-stocks-table-rows-per-page-state"
const PAGINATION_STATE = "products-stocks-table-pagination-state"

const PRODUCT_UPDATE_STOCK_TABLE_READY = "product-update-stocks-table-ready"

const PRODUCT_SELECTED = "product-selected"




const initialState = {
    isProductsStocksTableReady: true,
    isProductUpdateStockTableReady:true,
    productsStocks: {},

    
    productSelected: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case PRODUCTS_STOCKS_TABLE_READY:
            return Object.assign({}, state, { isProductsStocksTableReady: action.payload })
        case PRODUCT_UPDATE_STOCK_TABLE_READY:
            return Object.assign({}, state, { isProductUpdateStockTableReady: action.payload })


        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case PRODUCT_SELECTED:
            return Object.assign({}, state, {productSelected:action.payload})

        default:
        return state
    
    }

}

export function productsStocksTableReady(data) {
    return {
        type: PRODUCTS_STOCKS_TABLE_READY,
        payload: data
    }
}


export function productUpdateStockTableReady(data) {
    return {
        type: PRODUCT_UPDATE_STOCK_TABLE_READY,
        payload: data
    }
}



export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function productSelected(productId){
    return{
        type:PRODUCT_SELECTED,
        payload:productId
    }
}


// WEBPACK FOOTER //
// ./src/modules/ProductsStocks/redux/products_stocks.js